import { IUserInfo } from "@home-health-notify/domain";
import { Box, Button } from "@mui/material";
import { useTranslation } from "hhn-commons";
import React, { useState } from "react";
import CommonDialog from "../../../../../common/CommonDialog/CommonDialog";
import {
  KnowMeDivWrapper,
  KnowMeItemDivWrapper,
  TextareaAutosize,
} from "./KnowMeMore.style";

export const KnowMeMore = ({ userInfo }: { userInfo: IUserInfo }) => {
  const { t } = useTranslation();
  const tNs = (key: string) => t(key, { ns: "privateChatInfo" });

  const [isDialogOpen, setDialogOpen] = useState(false);

  const handleOpenDialog = () => {
    setDialogOpen(true);
  };

  const handleCloseDialog = () => {
    setDialogOpen(false);
  };

  return (
    <>
      <Box sx={{ padding: "20px" }}>
        <Button
          variant="contained"
          data-testid="knowMeMore-btn"
          onClick={handleOpenDialog}
          color="secondary"
        >
          {tNs("knowMeMoreBtn")}
        </Button>
      </Box>
      <CommonDialog
        isDialogOpen={isDialogOpen}
        onDialogClose={handleCloseDialog}
        title={tNs("knowMeMoreBtn")}
        titleAlignment="center"
        maxWidth={userInfo.knowMeMore.length > 1 ? "md" : "sm"}
      >
        {userInfo.knowMeMore.length > 0 ? (
          <div>
            {userInfo.knowMeMore.map((item: any, i: number) =>
              i % 2 === 0 ? (
                <KnowMeDivWrapper key={item._id}>
                  {/* First item */}
                  <KnowMeItemDivWrapper style={{ marginRight: "20px" }}>
                    <h4>{item.question}</h4>
                    <TextareaAutosize
                      value={item.answer}
                      readOnly
                      minRows={3}
                      nonce={undefined}
                      onPointerOverCapture={undefined}
                      onPointerMoveCapture={undefined}
                    />
                  </KnowMeItemDivWrapper>

                  {/* Second item if available */}
                  {i + 1 < userInfo.knowMeMore.length ? (
                    <KnowMeItemDivWrapper>
                      <h4>{userInfo.knowMeMore[i + 1].question}</h4>
                      <TextareaAutosize
                        value={userInfo.knowMeMore[i + 1].answer}
                        readOnly
                        minRows={3}
                        nonce={undefined}
                        onPointerOverCapture={undefined}
                        onPointerMoveCapture={undefined}
                      />
                    </KnowMeItemDivWrapper>
                  ) : userInfo.knowMeMore.length === 1 ? null : (
                    <KnowMeItemDivWrapper></KnowMeItemDivWrapper>
                  )}
                </KnowMeDivWrapper>
              ) : null,
            )}
          </div>
        ) : (
          <div style={{ textAlign: "center" }}>
            <p>{tNs("noQuestionsAnswered")}</p>
          </div>
        )}
      </CommonDialog>
    </>
  );
};
